import axios from '@axios'

export const state = {
  billings: [],
  blockedBalance: 0,
  balance: 0,
  billHistory: { balance: '0', amount: '0', accountBalance: '0' },
}

export const getters = {
  allBillings: (state) => state.billings,
  balance: (state) => state.balance,
  blockedBalance: (state) => state.blockedBalance,
  allBillHistory: (state) => state.billHistory,
}

export const mutations = {
  GET_BILLINGS: (state, billings) => {
    state.billings = billings
  },
  GET_BALANCE: (state, balance) => {
    state.balance = balance.balance
    state.blockedBalance = balance.blockedBalance
  },
  GET_BILL_HISTORY: (state, billHistory) => {
    if (!billHistory) {
      state.billHistory.balance = '0'
      state.billHistory.amount = '0'
      state.billHistory.accountBalance = '0'
      state.billHistory.billHistorys = []
    } else {
      state.billHistory = billHistory
    }
  },
  UPDATE_BILL_HISTORY: (state, updatedbillHistory) => {
    state.billHistory = { ...state.billHistory, ...updatedbillHistory }
  },
}

export const actions = {
  async getBillings({ commit }) {
    commit('GET_BILLINGS', [])
  },
  async getBalance({ commit }, userId) {
    let endPoint =
      userId > 0 ? `/billing/balance/${userId}` : '/billing/balance'
    axios
      .get(endPoint)
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_BALANCE', resp.data)
        }
      })
      .catch(() => {
        commit('GET_BALANCE', 0)
      })
  },
  async getBalanceById({ commit }, userId) {
    axios.get(`/billing/balance/${userId}`).then((resp) => {
      if (resp.status === 200) commit('UPDATE_BILL_HISTORY', resp.data)
    })
  },
  async getBillHistory({ commit, dispatch }, user) {
    return axios
      .get(`/billing/bill-history/${user.id}`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_BILL_HISTORY', resp.data)
        } else {
          commit('GET_BILL_HISTORY', false)
        }
      })
      .catch(() => {
        dispatch('billing/getBalanceById', user.id, { root: true })
        commit('GET_BILL_HISTORY', false)
      })
  },
}
